import { render } from "./ChartData.vue?vue&type=template&id=388455e2&scoped=true"
import script from "./ChartData.vue?vue&type=script&lang=js"
export * from "./ChartData.vue?vue&type=script&lang=js"

import "./ChartData.vue?vue&type=style&index=0&id=388455e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388455e2"]])

export default __exports__